import React from "react";

const DashboardCard = ({ title, value, subtitle }) => {
	return (
		<div className="flex flex-col m-4">
			<div
				className="form-section width-full rounded-b-none flex flex-wrap"
				style={{
					minHeight: "45px",
					fontSize: "1.8rem",
					marginLeft: "20px",
					margin: "15px 0px 0px 0px",
					padding: "1.5rem 2rem",
					fontWeight: "600",
				}}
			>
				{title}
			</div>
			<div
				className="form-section bg-white flex grow justify-center items-center flex-col rounded-t-none flex-wrap width-full"
				style={{
					padding: "0px 0px",
					//minWidth: "300px",
					boxSizing: "border-box",
					minHeight: "100px",
					margin: 0,
				}}
			>
				<div
					className="section-header"
					style={{ marginBottom: "5px", padding: "5px" }}
				>
					<div
						style={{
							display: "flex",
							fontSize: "clamp(2.25rem, 0.6316rem + 2.6316vw, 3rem)",
							fontWeight: "bold",
							color: "#333",
							justifyContent: "center",
						}}
					>
						{value}
					</div>
					<div
						style={{
							display: subtitle ? "flex" : "none",
							fontSize: "clamp(1.75rem, 1.6694rem + 0.6452vw, 2.25rem)",
							color: "#000",
							justifyContent: "center",
							fontWeight: "600",
						}}
					>
						{subtitle}
					</div>
				</div>
			</div>
		</div>
	);
};

const ChartCard = ({ title, chart }) => {
	return (
		<div
			className="flex flex-col"
			style={{ margin: 15 }}
		>
			<div
				className="form-section width-full rounded-b-none"
				style={{
					minHeight: "45px",
					fontSize: "1.8rem",
					marginLeft: "20px",
					margin: "15px 0px 0px 0px",
					padding: "1.5rem 2rem",
					fontWeight: "600",
				}}
			>
				{title}
			</div>
			<div
				className="flex justify-center items-center form-section bg-white rounded-t-none width-full flex-grow"
				style={{ margin: 0, padding: "10px", boxSizing: "border-box" }}
			>
				{chart}
			</div>
		</div>
	);
};

export { DashboardCard, ChartCard };
